import { jsx as _jsx } from "react/jsx-runtime";
import s from "./HiddenVisually.module.css";
const HiddenVisually = (props) => {
    const { children } = props;
    return _jsx("div", { className: s.root, children: children });
};
HiddenVisually.displayName = "HiddenVisually";
export default HiddenVisually;
